<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{
    caseTypes: (caseTypes$ | async) ?? [],
    selectedCaseType: (selectedCaseType$ | async)
  }"
></ng-container>

<ng-template
  #template
  let-caseTypes="caseTypes"
  let-selectedCaseType="selectedCaseType"
  let-disabled="disabled"
>
  <div *ngIf="!hideSelector" flexLayout="row">
    <mat-form-field>
      <mat-label [innerText]="label"></mat-label>
      <mat-select
        #caseTypeSelect
        [formControl]="formControl"
        (selectionChange)="selectionChanged($event)"
      >
        <mat-option [value]="null" *ngIf="showDefaultOption(caseTypes.length)">{{
          noneSelectedText
        }}</mat-option>
        <mat-option *ngFor="let casetype of caseTypes" [value]="casetype.caseTypeId">
          {{ casetype.displayName }}
        </mat-option>
      </mat-select>
      <mat-hint *ngIf="selectedCaseType && !hideDescription">
        Description: {{ selectedCaseType?.description }}
      </mat-hint>
    </mat-form-field>
  </div>
</ng-template>
